// extracted by mini-css-extract-plugin
export var rateTable = "_4m-0";